module.exports = __webpack_public_path__ + "static/img/pin-larvicide-active.527b85f.svg";